import { curry, isEmpty, pipe, groupBy, entries, map } from "lodash/fp";
const tensorize = curry((columns, data) => {
  if (isEmpty(columns)) {
    return null;
  }
  const [column, ...restCols] = columns;
  const items = pipe(
    groupBy(column),
    entries,
    map(([colValue, colData]) => ({
      value: colValue,
      key: colData.length === 1 && colData[0].key ? colData[0].key : null,
      span: colData.length,
      next: tensorize(restCols, colData)
    }))
  )(data);
  return {
    column,
    items
  };
});
export {
  tensorize
};
